const gridView = document.querySelectorAll('.grid-view span');
if (gridView) {
  gridView.forEach((el) => {
    const toggleActiveGrid = () => {
      gridView.forEach((el) => {
        el.classList.remove('active')
        el.removeAttribute('aria-current');
      });

      el.classList.add('active');
      el.setAttribute('aria-current', true)
      document.querySelector('#product-grid').dataset.view = el.dataset.gridView;
    }

    el.addEventListener('click', toggleActiveGrid);
    el.addEventListener('keypress', (e) => {
      if (e.key === 'Enter' || e.key === " ") {
        e.preventDefault();
        toggleActiveGrid();
      }
    });
  });
}

